import { render } from "./legoSwitch.vue?vue&type=template&id=05aa0410"
import script from "./legoSwitch.vue?vue&type=script&lang=js"
export * from "./legoSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoSwitch/legoSwitch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05aa0410"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05aa0410', __exports__)) {
    api.reload('05aa0410', __exports__)
  }
  
  module.hot.accept("./legoSwitch.vue?vue&type=template&id=05aa0410", () => {
    api.rerender('05aa0410', render)
  })

}


export default __exports__